import { frontendURL } from "../../../../helper/URLHelper";
import ViewKnowledge from "./index.vue";
import Document from "./documents/Document.vue";
import Testing from "./testing/Testing.vue";
import Settings from "./settings/Settings.vue";
import ViewDocument from "./documents/ViewDocument.vue";
import store from "../../../../store/index";
import { subscriptionGuard } from "../../../../helper/subscriptionHelper";
import Graph from "./graph/Graph.vue";

export default {
    routes: [
      {
        path: frontendURL('accounts/:accountId/knowledge/view/:id'),
        name: 'view_knowledge',
        component: ViewKnowledge,
        meta: {
          permissions: ['administrator', 'agent'],
        },
        // Router guard to check subscription using cached data
        beforeEnter: async (to, from, next) => {
          await subscriptionGuard(to, from, next, store);
        },
        redirect: { name: 'view_knowledge_documents' },
        children: [
          {
            path: 'document',
            name: 'view_knowledge_documents',
            component: Document,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
          {
            path: 'testing',
            name: 'view_knowledge_testing',
            component: Testing,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
          {
            path: 'settings',
            name: 'view_knowledge_settings',
            component: Settings,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
          {
            path: 'document/:documentId',
            name: 'view_document',
            component: ViewDocument,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
          {
            path: 'graph',
            name: 'view_knowledge_graph',
            component: Graph,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
        ]
      },
    ],
};